// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1kryR","tab":"ProcedureTabs_tab__1Q_89"};